import { Controller } from 'stimulus'

export default class extends Controller {
  onIsolateShow(e) {
    const [data, status, xhr] = e.detail
    $('#isolateDetailModalWrapper').html(xhr.response)
    $('#isolateDetailModal').modal('show')
  }
}